import React from 'react';
import {connect} from "react-redux";
import { Route, Link, NavLink } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import routes from '../../../routes';

const findRouteName = url => routes[url];

const getPaths = (pathname) => {
  const paths = ['/'];
  if (pathname === '/') return paths;

  pathname.split('/').reduce((prev, curr, index) => {
    const currPath = `${prev}/${curr}`;

    paths.push(currPath);
    return currPath;
  });

  return paths;
};

const BreadcrumbsItem =({ match }) => {
  const routeName = findRouteName(match.url);
  if (routeName) {
    return (
      match.isExact ?
      (
        <BreadcrumbItem active>{routeName}</BreadcrumbItem>
      ) :
      (
        <BreadcrumbItem>
          <Link to={match.url || ''}>
            {routeName}
          </Link>
        </BreadcrumbItem>
      )
    );
  }
  return null;
};

class BreadcrumbComponent extends React.Component {
  constructor(props){
    super(props)
    this.Breadcrumbs = this.Breadcrumbs.bind(this)
  }

  renderMenuRestriction() {
    const {pathname} = this.props.location
    const {UserReducer} = this.props
    
    // render menu admin
    if(UserReducer.props.isAdmin) {
      // Menu admin
      if(pathname.startsWith("/su")) {
        this.props.history.push('/page/restriction/')
      }

      let menu_admin = [
          <NavLink key={"ma1"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/home">Dashboard {/*<span className="badge badge-for-top-menu badge-pill badge-danger">2</span>*/}</NavLink>,
          <NavLink key={"ma2"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/assets">Assets /Tools</NavLink>,
          <NavLink key={"ma3"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/job">Jobs</NavLink>,
          <NavLink key={"ma4"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/user">Users</NavLink>,
          <NavLink key={"ma5"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/report">Reports</NavLink>,
          <NavLink key={"ma6"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/admin/all-activities">Admin</NavLink>,
          <NavLink key={"ma7"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/data-master/tenant-setting">Setting</NavLink>,
          <NavLink key={"ma8"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/admin/maintenance">Maintenance</NavLink>,
          <NavLink key={"ma9"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/admin/billing">Billing</NavLink>,
      ]
      return (menu_admin)

    } else if(UserReducer.props.is_superuser) {
      // Menu superuser
      if(pathname.startsWith("/data-master") || 
         pathname.startsWith("/home") || 
         pathname.startsWith("/assets") || 
         pathname.startsWith("/job") || 
         pathname.startsWith("/user") || 
         pathname.startsWith("/report")) {
         pathname.startsWith("/admin") || 
         pathname.startsWith("/su") || 
        this.props.history.push('/page/restriction/');
      }
      return null

    } else if(!UserReducer.props.isAdmin && !UserReducer.props.is_superuser) {
      // Menu common user
      if(pathname.startsWith("/data-master") || 
         pathname.startsWith("/admin") || 
         pathname.startsWith("/su") || 
         pathname.startsWith("/report")) {
        this.props.history.push('/page/restriction/');
      }

      let menu_user = [
        <NavLink key={"um1"} id="pull-padding-tb" activeClassName={ 'active-menubottom' } to="/home">Dashboard {/*<span className="badge badge-for-top-menu badge-pill badge-danger">2</span>*/}</NavLink>,
        <NavLink key={"um2"} id="pull-padding-tb" activeClassName={ 'active-menubottom' }  to="/assets">Assets /Tools</NavLink>,
        <NavLink key={"um3"} id="pull-padding-tb" activeClassName={ 'active-menubottom' }  to="/job">Jobs</NavLink>,
        <NavLink key={"um4"} id="pull-padding-tb" activeClassName={ 'active-menubottom' }  to="/user">Users</NavLink>,
      ]
      return (menu_user)
    }
  }

  Breadcrumbs = ({ location : { pathname }, match }) => {
    const paths = getPaths(pathname);
    // const i = 0;
    const items = paths.map( (path, i) => <Route key={i++} path={path} component={BreadcrumbsItem} /> );

    return (
      <div >
        <Breadcrumb className="hidden-md-down">
          {items}
        </Breadcrumb>

        {/* For Menu Top */}
        <Breadcrumb className="hidden-lg-up">
          {this.renderMenuRestriction()}   
        </Breadcrumb>
      </div>
    );
  };

  render() {
    return(
      <div>
        <Route path="/:path" component={this.Breadcrumbs} {...this.props} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      UserReducer: state.UserReducer
  };
};

const mapDispatchToProps = (dispatch) => {
    return {
        RunRedux: (data) => {
            dispatch(data);
        },
    };
};

// export default Header;
export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbComponent);




// WEBPACK FOOTER //
// ./src/App/views/components/Breadcrumb/Breadcrumb.js